<template>
  <div class="card-details">
    <div id="head-form-details">
        <i class="fas fa-edit"></i>
        <p id="text-head-detail">INFORMAÇÕES</p>
    </div>
    <div id="body-form-details">
        <div>
            <p class="title-body">SOLICITAÇÃO</p>
        </div>
        <div class="label-res">
            <p class="sub-title">Situação</p>
            <div class="styleSituacao" :style="colorSituacao ? 'background-color:#008144' : 'background-color:red' ">
                <p class="result-info situacao">{{descricaoSituacao}}</p>
            </div>
        </div>
        <div class="d-flex">
            <div class="label-res">
                <p class="sub-title">Dt Solicitação</p>
                <p class="result-info">{{ dataDetails.dataCriacao | formatDate}}</p>
            </div>
            <div class="second">
                <div class="label-res">
                    <p class="sub-title">Obra</p>
                     <p class="result-info">{{ dataDetails.obra ? dataDetails.obra.localizacao : 'N/D' }}</p>
                </div>
            </div>
        </div>
         <div class="d-flex">
            <div class="label-res">
                <p class="sub-title">Responsável</p>
                 <p class="result-info">{{ dataDetails.responsavel.nome }}</p>
            </div>
            <div class="second">
                 <div class="label-res">
                    <p class="sub-title">Regional</p>
                    <div class="result-info">{{dataDetails.secaoRH.nome}}</div>
                </div>
            </div>
        </div>
        <div class="label-res">
            <p class="sub-title">Solicitante</p>
            <div class="result-info">{{despesa == null ? dataDetails.contaCriacao.nome : despesa.solicitante == null ? dataDetails.contaCriacao.nome : despesa.solicitante }}</div>
        </div>
        <hr>
        <div class="viagem-header">
            <div class="w-50">
              <p class="title-body">VIAGEM</p>
            </div>
            <div class="edicao">
                <div class="button_Edicao" v-if="despesa.situacao == 1 && (hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL))">
                    <p @click="editPrestacao"><i class="fas fa-pen icone-pen"></i></p>
                </div>
            </div>
        </div>
         <div class="d-flex">
            <div class="label-res">
                <p class="sub-title">Periodo</p>
                <div class="result-info">{{despesa.dataViagemInicio }} á {{despesa.dataViagemFim }}</div>
            </div>
            <div class="second">
                <div class="label-res">
                    <p class="sub-title">Motivo</p>
                     <div class="result-info">{{despesa.motivoViagem}}</div>
                </div>
            </div>
        </div>
         <div class="d-flex">
            <div class="label-res">
                <p class="sub-title">Cidade Origem</p>
                <div class="result-info">{{despesa.cidadeOrigemNome  }}</div>
            </div>
            <div class="second">
                 <div class="label-res">
                    <p class="sub-title">Cidade Destino</p>
                    <div class="result-info">{{despesa.cidadeDestinoNome }}</div>
                </div>
            </div>
        </div>
         <div class="d-flex">
                <div class="label-res">
                    <p class="sub-title">Funcionário</p>
                    <div class="result-info" :class="isFired">{{dataDetails.favorecido.nome  }}</div>
                </div>
              <div class="second">
                 <div class="label-res">
                    <p class="sub-title">Função Funcionário</p>
                    <div class="result-info">{{dataDetails.favorecido.cargo.nome  }}</div>
                </div>
            </div>
        </div>
        <div class="d-flex">
              <div class="semAdiantamento">
                  <!-- <div><input type="checkbox" id="checkbox-circle1" name="check" :disabled="true" v-model="DespesasemAdiantamento"><span class="checkmark"></span></div> -->
                  <div class="sub-title">COM ADIANTAMENTO?</div>
                  <div class="result-info" :style="despesa.semAdiantamento ? 'color: red' : ''" v-if="despesa.semAdiantamento" >
                      Não
                  </div>
                  <div class="result-info" :style="!despesa.semAdiantamento ? 'color: #008144' : ''" v-else>
                      Sim
                  </div>
              </div>
          </div>
          <p class="sub-title">Observação</p>
          <div class="result-info">{{dataDetails.observacao  }}</div>
          <div class="d-flex justify-content-center button-footer">
                <button @click="aprovarModal" v-if="verificarAcessDes(despesa.situacao, dataDetails.solicitanteID) && despesa.situacao === 0" class="btn-apr">ENVIAR PARA APROVAÇÃO</button>
                <button @click="nextStatusDespesaAproved"  v-if="verificarAcessDes(despesa.situacao, despesa.solicitanteID) && despesa.situacao > 0 || (despesa.situacao == 8  && (hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELREFUND_COORDINATOR_SEARCH_CONTROLLER_APPROVAL))) && tabs != 2" class="btn-apr"><i class="fas fa-thumbs-up mr-2"></i>APROVAR</button>
          </div>
          <div class="d-flex justify-content-center mt-3">
                <button
                    @click="excluirTerm()"
                    v-if="verificarAcessDes(despesa.situacao, dataDetails.solicitanteID) && despesa.situacao === 0"
                    class="btn-exc"
                >
                    EXCLUIR
                </button>
                <!-- <button @click="reprovar" class="btn-rep"  v-if="verificarAcessDes(dataDetails.situacao, dataDetails.solicitanteID) && dataDetails.situacao > 0 || dataDetails.situacao == 8 && tabs != 2"><i class="fas fa-thumbs-down mr-2"></i>REPROVAR</button> -->
                <button @click="verificaAcessoContro()" class="btn-rep"  v-if="verificarAcessDes(despesa.situacao, dataDetails.solicitanteID) && despesa.situacao > 0 || despesa.situacao == 8 && tabs != 2"><i class="fas fa-thumbs-down mr-2"></i>REPROVAR</button>
          </div>
    </div>
    <b-modal
    hide-footer
    centered
    hide-header
    ref="next-status-modal"
    size="lg"
    id="add-newdespesa-modal"
    >
     <div class="px-2 py-2" v-if="flverificarItens">
      <div class="d-flex justify-content-end">
      <div @click="aprovarModalHide" class="button-close">X</div>
      </div>
      <div class="d-flex justify-content-center">
          <i class="fas fa-money-check-alt" style="color: #01572f; font-size: 50px"></i>
      </div>
       <div class="d-flex justify-content-center mt-2">
          <p class=" title-modal-nex">Deseja enviar a Prestação para aprovação?</p>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <button @click="aprovarModalHide"  class="btn-exc mx-2">NÃO</button>
        <button class="btn-apr mx-2" @click="nextStatusDespesaAproved">SIM</button>
      </div>
     </div>
     <div class="px-2 py-2" v-else>
      <div class="d-flex justify-content-end">
      <div @click="aprovarModalHide" class="button-close">X</div>
      </div>
      <div class="d-flex justify-content-center">
        <i  class="fas fa-info-circle icon-warning"></i>
      </div>
      <div class="d-flex justify-content-center mt-3">
         <p class=" title-modal-nex">Essa despesa possui itens ainda não incluidos</p>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <button @click="aprovarModalHide"  class="btn-apr  mx-2">OK</button>
      </div>
     </div>
    </b-modal>
    <b-modal
    hide-footer
    centered
    hide-header
    ref="OpenModalNonelote"
    size="lg"
    id="add-newdespesa-modal"
    >
     <div class="d-flex justify-content-center pt-5 pr-5 pl-5">
        <p class="title-modal-nex text-third">Essa prestação de conta não possui um lote, gostaria de aprovar sem a aprovação da diretoria?</p>
     </div>
     <div class="d-flex jusitfy-content-center  pb-5 pr-5 pl-5">
        <button class="btn-rep mx-2 w-50" @click="closemodalLote">Não</button>
        <button class="btn-apr  mx-2 w-50" @click="nextStatusNoneLote">Sim</button>
     </div>
    </b-modal>

    <b-modal
        hide-footer
        centered
        :title="'Reprovar Despesa'"
        size="lg"
        ref="reprova-despesa-presta-contas"
        id="history-lote">
            <div>
                <div  class="body-reprova">
                <i class="icone-pergunta fa fa-question-circle" aria-hidden="true"></i>
                </div>
                <div class="header-body">
                    <div class="header-reprova">
                        ATENÇÃO!
                    </div>
                    <div class="texto-reprova">
                        Deseja realmente REPROVAR essa despesa? escolha uma das opção para reprovação
                    </div>
                    <div  class="button-corpo">
                        <button  @click="reprovaPopUpClose " class="button-cance"> CANCELAR </button>
                        <button  @click="verificaAcessoElaboracao()" class="button-save"> VOLTAR PARA ELABORAÇÃO </button>
                        <button @click="verificaAcessoReprovadoDesconto()"   class="button-save" >DESCONTAR NA FOLHA </button>
                    </div>
                </div>
            </div>
    </b-modal>

    <b-modal
        hide-footer
        centered
        :title="'Reprovar Despesa'"
        size="lg"
        ref="reprova-despesa-presta-contas-coordenador"
        id="history-lote">
            <div>
                <div  class="body-reprova">
                <i class="icone-pergunta fa fa-question-circle" aria-hidden="true"></i>
                </div>
                <div class="header-body">
                    <div class="header-reprova">
                        ATENÇÃO!
                    </div>
                    <div class="texto-reprova">
                        Deseja realmente REPROVAR essa despesa? escolha uma das opção para reprovação
                    </div>
                    <div  class="button-corpo">
                        <button  @click="popUpcoordenadorreprovaClose " class="button-cance"> CANCELAR </button>
                        <button  @click="verificaAcessoElaboracao()" class="button-save"> VOLTAR PARA ELABORAÇÃO </button>
                        <button @click="verificaAcessoInativarAdiPresta()"   class="button-save" >INATIVAR TERMO</button>
                    </div>
                </div>
            </div>
    </b-modal>

    <b-modal
            hide-footer
            centered
            :title="'EDITAR VIAGEM'"
            size="lg"
            ref="edita-viagem-prest"
            id="edita-viagem-prest">
                <div>
                  <div class="header-body">
                    <div class="card-solicitacao">
                        <div class="label-num">FUNCIONÁRIO</div>
                         <div class="numSolicita">{{dataDetails.favorecido.nome}}</div>
                    </div>
                    <div class="d-flex">
                        <div class="col-md-6">
                            <label class="label-search">Pais / Estado / Cidade Origem:</label>
                            <div class="d-flex local_destino">
                                <b-form-select v-model="form.paisOrigemID.value" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeCountryEnd">
                                    <template slot="first" v-if="dataCountry.length >= 2">
                                    <option :value="null" >Selecione</option>
                                    <option  v-for="data in dataCountry" :key="data.id" :value="data.id">{{data.nome}}</option>
                                    </template>

                                    <template slot="first" v-else>
                                    <option  :value="null">{{dataCountry[0].nome}}</option>
                                    </template>
                                </b-form-select>
                                <b-form-select v-model="despesa.estadoOrigemId" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeStateOrigem">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataStateFim" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                                <b-form-select v-model="despesa.cidadeOrigemId" class="mb-3" style="max-width: 180px;margin-right: 2px">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataCityOrigem" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="label-search">Pais / Estado / Cidade Destino:</label>
                            <div class="d-flex local_destino">
                                <b-form-select v-model="form.paisDestinoID.value" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeCountryFim">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataCountry" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                                <b-form-select v-model="despesa.estadoDestinoID" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeStateFim">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataStateFim" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                                <b-form-select v-model="despesa.cidadeDestinoId" class="mb-3" style="max-width: 180px;margin-right: 2px">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataCityFim" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex">
                        <div class="col-md-12" v-if="solicitanteEdicao === true">
                            <label class="label-search">Solicitante</label>
                            <div class="d-flex">
                                        <autocomplete-z ref="responsavelTypeaheads"
                                        iconClass="fas fa-users"
                                        placeholder="Digite o código do Responsável"
                                        :showAllResults="true"
                                        :serializer="(responsavels) => responsavels.codigo + ' - ' + responsavels.nome"
                                        debounceLength="1"
                                        :ShowCode="false"
                                        :formField="BuscaCodigo"
                                        v-on:search="onSearchResponsavelCode" />
                                        <autocomplete-z ref="responsavelTypeahead"
                                        placeholder="Digite o nome do Responsável"
                                        :showAllResults="true"
                                        :serializer="(responsavels) => responsavels.codigo + ' - ' + responsavels.nome"
                                        debounceLength="4"
                                        :ShowCode="false"
                                        :disabled="codigoResponsavel"
                                        :formField="BuscaNome"
                                        v-on:search="onSearchResponsavel" />
                            </div>
                        </div>
                        <div class="col-md-11" v-if="solicitanteEdicao === false">
                            <label class="label-search">*Responsável (Coordenador Obra)</label>
                            <input v-model="despesa.solicitante" class="input-details" disabled>
                        </div>
                        <div class="col-md-1 ajuste-icone" v-if="solicitanteEdicao === false">
                            <button @click="editarSolitante"  class="button-editar"><i class="fas fa-pen" style="color: #ffffff;"></i></button>
                        </div>
                    </div>

                    <div class="d-flex">
                        <div class="col-md-4">
                            <label class="label-search">Inicio Viagem:</label>
                            <datepicker name="txtDateStart"
                                v-model="despesa.inicio"
                                :format="'dd/MM/yyyy'"
                                :language="ptBR"
                                :placeholder="$lang.Common.DatePlaceholder"
                                :clear-button="true"
                                :clear-button-icon="'fa fa-close'"
                                :calendar-button="true"
                                :calendar-button-icon="'fa fa-calendar'"
                                :bootstrap-styling="true"
                                :full-month-name="true"
                                :initialView="'day'"
                                :use-utc="true"/>
                        </div>
                        <div class="col-md-4">
                            <label class="label-search">Fim Viagem:</label>
                            <datepicker name="txtDateStart"
                                v-model="despesa.fim"
                                :format="'dd/MM/yyyy'"
                                :language="ptBR"
                                :placeholder="$lang.Common.DatePlaceholder"
                                :clear-button="true"
                                :clear-button-icon="'fa fa-close'"
                                :calendar-button="true"
                                :calendar-button-icon="'fa fa-calendar'"
                                :bootstrap-styling="true"
                                :full-month-name="true"
                                :initialView="'day'"
                                :use-utc="true"/>
                        </div>

                        <div class="col-md-4">
                            <label class="label-search">Motivo Viagem:</label>
                            <b-form-select v-model="despesa.motivoViagemId">
                                <template slot="first">
                                    <option :value="null">Selecione</option>
                                    <option v-for="data in dataTravel" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </template>
                            </b-form-select>
                        </div>
                    </div>
                      <div  class="button-corpo">
                        <button @click="fecharPopUp"  class="button-cance"> CANCELAR </button>
                        <button @click="EditarTermo" class="button-save" >SALVAR </button>
                      </div>
                  </div>
              </div>
          </b-modal>
  </div>
</template>

<script>
import PanelTravel from './PanelTravel'
export default PanelTravel
</script>

<style scoped>
.ajuste-icone{
    display: flex;
    justify-content: end;
    align-items: flex-end;
}
.input-details{
    width: 100%;
    height: 36px;
    background-color: 100%;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
    outline: none;
    padding-left: 1rem;
}
.button-editar{
  margin-top: 10;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 36px;
  height: 40px;
}
.button-editar{
  background-color: #008148;
  color: white;
}
.label-search{
    padding-bottom: 0px;
    margin: 18px 0 10px 0;
    font-weight: bold;
}
.label-num{
    text-align: center;
}
.numSolicita{
    text-align: center;
    font-size: 16px;
    color: #008144;
    font-weight: bold;
}
.card-solicitacao{
   background-color: #f1f1f1;
    width: 95%;
    display: flex;
    height: fit-content;
    padding: 1rem;
    gap: 1rem;
    border-radius: 12px;
    margin: 0 0 0 1rem;
}
.viagem-header{
    display: flex;
    width: 100%;
}
.edicao{
    width: 50%;
    display: flex;
    justify-content: end;
}
.icone-pen{
    font-size: 15px;
    color: white;
    cursor: pointer;
}
.button_Edicao {
    background-color:  #008148;
    width: 30%;
    height: 2rem;
    padding: 7px;
    display: flex;
    justify-content: center;
    border-radius: 10px;
}
.button-cance{
   outline: transparent;
   border: transparent;
   border-radius: 4px;
   text-transform: uppercase;
   width: 210px;
   height: 40px;
   background-color: #aa1414;
   color: white;
}
.button-save{
   outline: transparent;
   border: transparent;
   border-radius: 4px;
   text-transform: uppercase;
   width: 210px;
   height: 40px;
   background-color: #008148;
   color: white;
}
.button-corpo{
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 3rem;
}
.icone-pergunta{
  font-size: 60px;
  color:#008144
}
.header-reprova{
  font-size: 23px;
  color: #797878;
  font-weight: bold;
  display: flex;
  justify-content: center;
  margin: 1rem;
}
.body-reprova{
  display: flex;
  justify-content: center;
}
.texto-reprova{
  display: flex;
    justify-content: center;
    font-size: 15px;
    margin-top: 1rem;
}
.semAdiantamento{
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-top: 2.5rem;
}
.button-close{
  background: grey;
  height: 45px;
  width: 45px;
  display: flex;
  justify-content: center;
  color: white;
  align-items: center;
  cursor: pointer;
  font-size: 20px;
  border-radius: 50%;
}
.title-modal-nex{
  font-size: 18px;
  font-weight: bold;
}
.result-info{
    font-weight: bold;
    margin: 0px;
    padding: 0px;
    font-size: 14px !important;
}
.result-info-red{
    font-weight: bold;
    margin: 0px;
    font-size: 14px !important;
    padding: 0px;
    color: #dc3545;
}
.card-details{
    height: 100%;
    background: white;
    border-radius: 10px 10px 0px 0px;
}
#body-form-details{
    padding: 25px;
}
#head-form-details{
    width: 100%;
    height: 40px;
    display: flex;
    padding-left: 15px;
    color:#008144;
    align-items: center;
    background: #ECEFF1;
    border-radius: 10px 10px 0px 0px;
}
.icon-warning{
  font-size: 60px;
  color: rgb(179, 179, 2);
}
.situacao{
    font-weight: bold;
    color: white;
    font-size: 10px !important;
}
#title-modal-cus{
  background: white;
}
.modal-header {
  padding: 0px;
  display: none !important;
}
.label-res{
    max-width: 40%;
    min-width: 40%;
}
.btn-apr{
    background: #008144;
    width: 80%;
    height: 40px;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
}
.btn-apr:hover{
    background: #01572f;

}
.btn-rep:hover{
    background: rgb(160, 0, 0);
}
.button-footer{
    margin-top: 50px;
}
.btn-exc{
    background: #ECEFF1;
    width: 80%;
    height: 40px;
    color: black;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
}
.btn-rep{
    background: red;
    width: 80%;
    height: 40px;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
}
#text-head-detail{
    padding-left: 8px;
    padding-top: 19px;
    font-weight: bold;
}
.second{
    padding-left: 75px;
}
.title-body{
    font-size: 14px;
    font-weight: bold;
    color: #008144;
}
.sub-title{
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 0px;
    font-weight: 500;
}
.styleSituacao {
    width: 180px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    font-size: 10px;
    border-radius: 25px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/PanelTravel/PanelTravel.vue